import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import enTranslations from './locales/en.json';
import thTranslations from './locales/th.json';

/**
 * i18n bootstrap. Imported for its side effect from `main.tsx` (and the test setup, so tests
 * render real strings). Resources are bundled inline — no async loading, so the first render
 * already has translations. English is both the fallback and the language every test runs in;
 * the detector caches the operator's choice in localStorage.
 */
void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslations },
      th: { translation: thTranslations },
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'th'],
    nonExplicitSupportedLngs: true,
    interpolation: {
      escapeValue: false, // React already escapes
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
  });

export default i18n;
